"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrubData = exports.scrubString = exports.getProvince = exports.getOrderTypeOrDefault = exports.buildLocale = exports.getDefaultProv = exports.getDefaultLang = void 0;
const tslib_1 = require("tslib");
const get_1 = tslib_1.__importDefault(require("lodash/get"));
const constants_1 = require("../constants");
const REGEX_EXP_TO_SCRUB = [
    {
        exp: /(^.*?\/account\/)(\d+)(.*?$)/,
        redactionIndex: [2]
    },
    {
        exp: /(^.*?\/sub\/)(\d+)(.*?$)/,
        redactionIndex: [2]
    },
    { exp: /(^.*?\/accounts\/)(\d+)(\/subscribers\/)(\d+)(.*?$)/, redactionIndex: [2, 4] },
    {
        exp: /(Bearer\s+)(\S+)(.*?$)/,
        redactionIndex: [2]
    }
];
const ATTRIBUTES_TO_SCRUB = ['authorization', 'Authorization'];
/**
 * Return default language
 *
 * @returns {Language} lang
 */
const getDefaultLang = () => constants_1.LANGUAGE.EN;
exports.getDefaultLang = getDefaultLang;
/**
 * Return default province
 *
 * @returns {Province}
 */
const getDefaultProv = () => constants_1.PROVINCE.ON;
exports.getDefaultProv = getDefaultProv;
/**
 * Return locale from lang and prov (optional)
 *
 * @param lang {string|undefined}
 * @param prov {string|undefined}
 * @returns {string}
 */
const buildLocale = (lang = 'en', prov = undefined) => {
    const provPrefix = typeof prov === 'string' && prov.length === 2 ? `-${prov.toUpperCase()}` : '';
    return `${lang}-CA${provPrefix}`;
};
exports.buildLocale = buildLocale;
/**
 * Returns the current order type or the default of `Activation` depending on if the argument is defined or is a valid order type.
 * @param sessionOrderType
 * @returns
 */
const getOrderTypeOrDefault = (sessionOrderType) => {
    const orderType = sessionOrderType !== undefined && constants_1.ORDER_TYPES[sessionOrderType]
        ? constants_1.ORDER_TYPES[sessionOrderType]
        : constants_1.ORDER_TYPES.ACTIVATION;
    return orderType;
};
exports.getOrderTypeOrDefault = getOrderTypeOrDefault;
/**
 * Takes in the session and context objects and resolves the correct Province to be returned.
 * @param session
 * @param orderType
 * @param context a plain object containing external attributes (eg. cookies, middleware, etc.)
 * @returns {Province}
 */
const getProvince = (session, orderType, context) => {
    var _a;
    // on RENEWAL return subscriber province
    const subcriberProv = (0, get_1.default)(session, 'koodo.subscriber.provinceCd');
    if (orderType === constants_1.ORDER_TYPES.RENEWAL && subcriberProv) {
        return subcriberProv;
    }
    // on AAL return account province
    const accountBillingProv = (0, get_1.default)(session, 'koodo.account.billingProvinceCd');
    if (orderType === constants_1.ORDER_TYPES.AAL && accountBillingProv) {
        return accountBillingProv;
    }
    // return context prov or default one
    const prov = (0, get_1.default)(context, 'prov');
    return (_a = prov) !== null && _a !== void 0 ? _a : (0, exports.getDefaultProv)();
};
exports.getProvince = getProvince;
/**
 * Scrubs sensitive information from a given string based on predefined regular expressions.
 * @param {string} str - The string to be scrubbed.
 * @returns {string} - The scrubbed string with sensitive information replaced by 'REDACTED'.
 */
const scrubString = (str) => {
    return REGEX_EXP_TO_SCRUB.reduce((acc, { exp, redactionIndex }) => {
        const matchResult = acc.match(exp);
        if (matchResult) {
            redactionIndex.forEach((index) => {
                const valueToRedact = matchResult[index];
                if (valueToRedact) {
                    acc = acc.replace(valueToRedact, 'REDACTED');
                }
            });
        }
        return acc;
    }, str);
};
exports.scrubString = scrubString;
/**
 * Scrubs sensitive information from a given string or object containing string values.
 * If the input is a string, it scrubs the string. If the input is an object, it scrubs all string values.
 * @param {string | Record<string, any>} data - The string or object to be scrubbed.
 * @returns {string | Record<string, any>} - The scrubbed string or object with sensitive information replaced by 'REDACTED'.
 */
const scrubData = (data) => {
    if (typeof data === 'string') {
        return (0, exports.scrubString)(data);
    }
    else if (Array.isArray(data)) {
        return data.map((item) => (0, exports.scrubData)(item));
    }
    else if (typeof data === 'object' && data !== null) {
        const redactedData = {};
        for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                const value = data[key];
                if (typeof value === 'string') {
                    redactedData[key] = (0, exports.scrubString)(value);
                }
                else if (typeof value === 'object' && value !== null) {
                    redactedData[key] = (0, exports.scrubData)(value);
                }
                else {
                    redactedData[key] = value;
                }
                if (ATTRIBUTES_TO_SCRUB.includes(key)) {
                    redactedData[key] = 'REDACTED';
                }
            }
        }
        return redactedData;
    }
    else {
        return data;
    }
};
exports.scrubData = scrubData;
//# sourceMappingURL=index.js.map